import React, { useEffect, useState, useMemo } from 'react';
import List from '@mui/material/List';
import BackgroundMusicListItem from '../items/BackgroundMusicListItem';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PerformanceListItem from '../items/PerformanceListItem';
import IntervalService from './../../services/intervals';
import EditPerformance from '../dialogs/EditPerformance';
import BackgroundHistoryListItem from '../items/BackgroundHistoryListItem';
import TrackAlreadyQueue from '../dialogs/TrackAlreadyQueue';
import AddBackgroundMusic from '../dialogs/AddBackgroundMusic';
import singersStore from './../../stores/singers';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import favoritesStore from './../../stores/favorites';
import settingsStore from '../../stores/settings';
import playerStore from './../../stores/player';
import musicPlayerStore from '../../stores/musicPlayer';
import bgPerformanceStore from '../../stores/bgPerformance';

function BackgroundHistoryList(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const setIsPaused = musicPlayerStore((state) => state.setIsPaused);
  const getSingers = singersStore((state) => state.getSingers);
  const singers = singersStore((state) => state.singers);
  const playQueue = bgPerformanceStore((state) => state.playQueue);
  const addPerformanceToPlayQueue = bgPerformanceStore((state) => state.addPerformanceToPlayQueue);
  const isMusicPlaying = musicPlayerStore((state) => state.isPlaying);
  const musicPlayLists = bgPerformanceStore((state) => state.playLists);
  const addPerformanceToMusicPlayQueue = bgPerformanceStore((state) => state.addPerformanceToPlayQueue);
  const addToBackgroundMusicPlayList = bgPerformanceStore((state) => state.addPerformanceToPlayList);
  const isPlayerStopped = playerStore((state) => state.isStopped);
  const isMusicOn = musicPlayerStore((state) => state.isMusicOn);
  const getStreamUrl = musicPlayerStore((state) => state.getStreamUrl);
  const streamUrl = musicPlayerStore((state) => state.streamUrl);
  const historyItems = bgPerformanceStore((state) => state.history?.items);
  const currentTrack = musicPlayerStore((state) => state.currentTrack);
  const currentPerformance = bgPerformanceStore((state) => state.currentPerformance);

  const [isAddBackgroundMusicOpen, setIsAddBackgroundMusicOpen] = useState(false);
  const [isTrackAlreadyQueueOpen, setIsTrackAlreadyQueueOpen] = useState(false);
  const [chosenTrackBackgroundMusic, setChosenTrackBackgroundMusic] = useState({});
  const [chosenPlayList, setChosenPlayList] = useState(null);

  const handleOpenAddBackgroundMusic = (track) => {
    setChosenTrackBackgroundMusic(track);
    setIsAddBackgroundMusicOpen(true);
  };

  const handleCloseAddBackgroundMusic = () => {
    setIsAddBackgroundMusicOpen(false);
  };

  const handleOpenTrackAlreadyQueue = (track) => {
    setIsTrackAlreadyQueueOpen(true);
  };

  const handleCloseTrackAlreadyQueue = () => {
    setIsTrackAlreadyQueueOpen(false);
  };

  const handleConfirmDoubleTrack = () => {
    if (chosenPlayList) {
      addToBackgroundMusicPlayList(sessionToken, chosenTrackBackgroundMusic, singers[0], chosenPlayList.id);
    }
    handleCloseTrackAlreadyQueue();
  };

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  const play = () => {
    if (!isPlayerStopped.isStopped) {
      setIsPaused(false);
    } else {
      if (isMusicOn) {
        if (streamUrl.length == 0) {
          console.log("stream_url_get");
          getStreamUrl(sessionToken, currentPerformance, currentTrack, singers[0], true);
        } else {
          setIsPaused(false);
        }
      }
    }
  };

  const handleAddBackgroundMusic = (playList, pos, playNow) => {
    if (playList) {
      let isAlreadyOnPlayList = false;
      for (var i = 0; i < playList.items.length; i++) {
        let track = playList.items[i].track;
        console.log(playList, track.track_id, chosenTrackBackgroundMusic.track_id);
        if (track.track_id === chosenTrackBackgroundMusic.track_id) {
          isAlreadyOnPlayList = true;
          break;
        }
      }
      if (isAlreadyOnPlayList) {
        setChosenPlayList(playList);
        handleOpenTrackAlreadyQueue();
      } else {
        setChosenPlayList(null);
        addToBackgroundMusicPlayList(sessionToken, chosenTrackBackgroundMusic, singers[0], playList.id);
      }
    } else {
      addPerformanceToMusicPlayQueue(sessionToken, chosenTrackBackgroundMusic, singers[0], pos, false, playNow);
    }
  };

  const historyItemIds = useMemo(() => {
      return historyItems?.map((p) => p.unique_id);
    }, [historyItems]);

  const historyList = useMemo(() => {
    if (historyItemIds) {
      return historyItemIds.map((performanceId, index) =>
        <BackgroundHistoryListItem
          key={performanceId}
          index={index}
          count={historyItemIds.length}
          onAddBackgroundMusic={(e, performance) => {
            e.preventDefault();
            handleOpenAddBackgroundMusic(performance.track);
          }}
        />
      );
    }
  }, [historyItemIds]);

  return (
    <div style={{ padding: 0 }}>
      <TrackAlreadyQueue
        open={isTrackAlreadyQueueOpen}
        onClose={handleCloseTrackAlreadyQueue}
        onConfirmation={handleConfirmDoubleTrack}
      />
      <AddBackgroundMusic
        open={isAddBackgroundMusicOpen}
        onClose={handleCloseAddBackgroundMusic}
        onAddBackgroundMusic={handleAddBackgroundMusic}
        track={chosenTrackBackgroundMusic}
        singers={singers}
        playQueue={playQueue}
        isPlaying={isMusicPlaying.isPlaying}
        playLists={musicPlayLists}
      />
      <List className="muvika-background-history-list">
        {historyList}
      </List>
    </div>
  );
}

export default BackgroundHistoryList;